export default "/fonts/vendor/fontsource-roboto/files/roboto-greek-ext-400-normal.woff2?bc7ace6e50c7d9d4d95923b61b1de59c";